import React from "react";
import InputMask from "@mona-health/react-input-mask";

const TextInputMaskFormik = ({ formik, field, format, placeholder, mask, disabled, evento }) => (
  <>
    <InputMask
      id={field}
      name={field}
      format={format}
      placeholder={placeholder}
      mask={mask}
      disabled={formik.isSubmitting || disabled}
      value={formik.values[field]}
      onChange={formik.handleChange}
      onBlur={evento}
      isInvalid={formik.touched[field] && formik.errors[field]}
      className={
        formik.touched[field] && formik.errors[field]
          ? "form-control-mascara-data is-invalid"
          : "form-control-mascara-data"
      }
    />
    {formik.touched[field] && formik.errors[field] && <div className="invalid-feedback">{formik.errors[field]}</div>}
  </>
);

export default TextInputMaskFormik;
